import {
  Action,
  DrawingActionKind,
  InitialOverlayAction,
  Overlay,
  RemoveOverlayAction,
  Snapshot,
  State,
} from 'features/locationMap/types'

export default function reducer(state: State, action: Action) {
  switch (action.type) {
    case DrawingActionKind.SET_INITIAL_OVERLAYS: {
      const polygons = (action as InitialOverlayAction).payload
      return {
        now: polygons.map(polygon => {
          const snapshot: Snapshot = {}
          snapshot.path = polygon.map(p => new google.maps.LatLng(p[1], p[0]))
          return {
            type: google.maps.Polygon,
            geometry: new google.maps.Polygon({
              paths: snapshot.path,
              editable: true,
              draggable: false,
              fillColor: '#528DE0',
              fillOpacity: 0.25,
              strokeColor: '#0A57C2',
              strokeWeight: 2,
            }),
            snapshot,
          }
        }),
      }
    }

    case DrawingActionKind.UPDATE_OVERLAYS: {
      const overlays = state.now.map((overlay: Overlay) => {
        const snapshot: Snapshot = {}
        const { geometry } = overlay
        snapshot.path = geometry.getPath()?.getArray()

        return {
          ...overlay,
          snapshot,
        }
      })

      return {
        now: [...overlays],
      }
    }

    case DrawingActionKind.SET_OVERLAY: {
      const { overlay } = action.payload
      const snapshot: Snapshot = {}
      snapshot.path = overlay.getPath()?.getArray()

      return {
        now: [
          ...state.now,
          {
            type: action.payload.type,
            geometry: action.payload.overlay,
            snapshot,
          },
        ],
      }
    }

    case DrawingActionKind.REMOVE_OVERLAY: {
      const index = (action as RemoveOverlayAction).payload
      const newPolygons = [...state.now]
      newPolygons.splice(index, 1)
      return { now: newPolygons }
    }

    default:
      return state
  }
}
